import React from 'react';
import PropTypes from 'prop-types';
import {
  LeadingActions,
  SwipeableList as List,
  SwipeableListItem,
  SwipeAction,
  TrailingActions,
  Type,
} from 'react-swipeable-list';
import { isFunction } from 'lib';
import 'react-swipeable-list/dist/styles.css';

export default function SwipeableList({
  items = [],
  renderItem,
  leadingActions,
  trailingActions,
  swipeableListProps,
  swipeableListItemProps,
  leadingActionProps,
  trailingActionProps,
  className,
}) {
  return (
    <List
      className={className}
      fullSwipe={true}
      type={Type.IOS}
      {...swipeableListProps}
    >
      {items.map((item, index) => (
        <SwipeableListItem
          key={index}
          leadingActions={
            leadingActions && (
              <LeadingActions>
                <SwipeAction
                  {...leadingActionProps}
                  onClick={() => {
                    if (isFunction(leadingActionProps?.onClick))
                      leadingActionProps.onClick(item, index);
                  }}
                >
                  {leadingActions}
                </SwipeAction>
              </LeadingActions>
            )
          }
          trailingActions={
            trailingActions && (
              <TrailingActions>
                <SwipeAction
                  {...trailingActionProps}
                  onClick={() => {
                    if (isFunction(trailingActionProps?.onClick))
                      trailingActionProps.onClick(item, index);
                  }}
                >
                  {trailingActions}
                </SwipeAction>
              </TrailingActions>
            )
          }
          {...swipeableListItemProps}
        >
          {renderItem(item, index)}
        </SwipeableListItem>
      ))}
    </List>
  );
}

SwipeableList.propTypes = {
  items: PropTypes.array,
  renderItem: PropTypes.func,
  leadingActions: PropTypes.element,
  trailingActions: PropTypes.element,
  swipeableListProps: PropTypes.object,
  swipeableListItemProps: PropTypes.object,
  leadingActionProps: PropTypes.object,
  trailingActionProps: PropTypes.object,
  className: PropTypes.string,
};
